import {
  Menu,
  MenuItemRadio,
  MenuList,
  MenuPopover,
  MenuTrigger,
  ToolbarButton,
  Tooltip,
} from '@fluentui/react-components';

import { MODE_ICONS, MODE_LABELS, MODE_ORDER } from '@/theme/themeModes';
import { useAppTheme } from '@/theme/useAppTheme';
import type { ThemeMode } from '@/theme/themeStorage';

/**
 * The light/dark/system control in the top bar.
 *
 * It stays here even though the settings page offers the same choice: this one
 * is also mounted in AuthLayout, so it is the only theme control reachable
 * before sign-in. Both read the same context, so they can never disagree.
 */
export function ThemeToggle() {
  const { mode, setMode } = useAppTheme();

  return (
    <Menu
      checkedValues={{ theme: [mode] }}
      onCheckedValueChange={(_event, data) => {
        const next = data.checkedItems[0];
        if (next) setMode(next as ThemeMode);
      }}
    >
      <MenuTrigger disableButtonEnhancement>
        <Tooltip content="Change theme" relationship="label">
          <ToolbarButton aria-label="Change theme" icon={MODE_ICONS[mode]} />
        </Tooltip>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {MODE_ORDER.map((option) => (
            <MenuItemRadio key={option} name="theme" value={option} icon={MODE_ICONS[option]}>
              {MODE_LABELS[option]}
            </MenuItemRadio>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
